import React, { Component } from 'react';

export interface Benchmark
{
	title: JSX.Element | string
	value: string
}
export interface BenchmarksProps
{
	benchmarks: Benchmark[]
}

export default class Benchmarks extends Component<BenchmarksProps>
{
	render()
	{
		return(
			<React.Fragment>
				{this.props.benchmarks.map( (benchmark, i) => {
					return (
						<React.Fragment key={i}>
							<p className="margin-0 light-text" data-testid="benchmarkCategory">{benchmark.title}</p>
							<p data-testid="benchmarkCategoryName">{benchmark.value}</p>
							{i < (this.props.benchmarks.length -1) &&
							<hr />
							}
						</React.Fragment>
					);
				})}
			</React.Fragment>
		);
	}
}